// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(message_text, vehicle_category, geo_region) {
  vehicle_category !== 0;
  return {
          title_text: "कैंसलेशन स्कोर",
          learn_more_text: "अधिक जानिए",
          info_btn_details: {
            video_url: undefined,
            question: "कैंसलेशन स्कोर की गणना कैसे की जाती है?",
            answer: "कैंसलेशन स्कोर की गणना आपके द्वारा स्वीकार किए गए अंतिम 30 ऑर्डर में ड्राइवर द्वारा किए गए कैंसलेशनो की कुल संख्या के आधार पर की जाती है।"
          },
          learn_more_btn_details: [
            {
              video_url: PartnerContentHelper.getV2LearnMoreVid(geo_region),
              question: "कैंसलेशन स्कोर क्या है और यह महत्वपूर्ण क्यों है?",
              answer: ""
            },
            {
              video_url: undefined,
              question: "मुझे कब ससपेंड किया जाएगा?",
              answer: "जब भी आप कोई स्तर पार करेंगे तो आपको संबंधित अवधि के लिए ससपेंड कर दिया जाएगा।"
            },
            {
              video_url: undefined,
              question: "प्रत्येक स्तर के लिए सस्पेंशन अवधि क्या है?",
              answer: "प्रत्येक स्तर पर सस्पेंशन की अवधि को सस्पेंशन गाइड में जांचा जा सकता है।"
            },
            {
              video_url: undefined,
              question: "मैं कैंसलेशन स्कोर क्यों नहीं देख पा रहा हूँ?",
              answer: "कैंसलेशन स्कोर की गणना केवल उन पार्टनरों के लिए की जाती है जिन्होंने हाल के महीनों में कम से कम 30 ऑर्डर स्वीकार किए हैं।"
            }
          ],
          locked_score_msg: "कैंसलेशन स्कोर अनलॉक करने के लिए अधिक ऑर्डर स्वीकार करें।",
          message_text: message_text,
          suspension_guide_text: "सस्पेंशन गाइड",
          suspension_guide_table_details: {
            cancellation_score_text: "कैंसलेशन स्कोर",
            suspension_days_text: "निलंबन के दिन"
          }
        };
}

export {
  getContent ,
  
}
/* No side effect */
